import { Key_instance17dpgmdbeabno as Key_instance } from '../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { awaitCancellation1jy7bzelv7wwn as awaitCancellation } from '../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { throwKotlinNothingValueException2lxmvl03dor6f as throwKotlinNothingValueException } from '../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_awaitCleanup__8ytu3q($this, block, $completion) {
  // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
  // Inline function 'kotlin.js.getCoroutineContext' call
  // Inline function 'kotlin.check' call
  if (!($completion.rc().hd(Key_instance) === $this.p1m_1)) {
    var message = 'awaitCleanup() can only be invoked from the cleanup context';
    throw IllegalStateException().o(toString(message));
  }
  $this.q1m_1(block);
  var tmp = awaitCancellation($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  throwKotlinNothingValueException();
}
var CleanupScopeClass;
function CleanupScope() {
  if (CleanupScopeClass === VOID) {
    class $ {
      constructor(source, saveCleanup) {
        this.p1m_1 = source;
        this.q1m_1 = saveCleanup;
      }
      r1m(block, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_awaitCleanup__8ytu3q.bind(VOID, this, block), $completion);
      }
      ew() {
        return this.p1m_1.ew();
      }
    }
    initMetadataForClass($, 'CleanupScope', VOID, VOID, [CoroutineScope()], [1]);
    CleanupScopeClass = $;
  }
  return CleanupScopeClass;
}
//region block: exports
export {
  CleanupScope as CleanupScope28orczoi9dcjw,
};
//endregion

//# sourceMappingURL=CleanupScope.mjs.map
